// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { fireNonCancelableEvent } from '../../internal/events';
import { useLoadItems as useBaseLoadItems } from '../../internal/hooks/use-load-items';
export const useLoadItems = ({ onLoadItems, items, statusType }) => {
    const base = useBaseLoadItems({ onLoadItems, isEmpty: items.length === 0, statusType });
    const fireLoadItems = (filteringText) => {
        if (onLoadItems) {
            base.fireLoadItems(filteringText);
        }
    };
    const handleRecoveryClick = (expandedGroupId) => expandedGroupId
        ? fireNonCancelableEvent(onLoadItems, { firstPage: false, samePage: true, filteringText: '', expandedGroupId })
        : base.handleRecoveryClick();
    const fireGroupLoadItems = (expandedGroupId) => fireNonCancelableEvent(onLoadItems, { filteringText: '', firstPage: true, samePage: false, expandedGroupId });
    return {
        fireLoadItems,
        handleLoadMore: base.handleLoadMore,
        handleRecoveryClick,
        fireGroupLoadItems,
    };
};
//# sourceMappingURL=use-load-items.js.map